import currenciesModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';
import currenciesLookup from './currenciesLookup';

const STORE_NAME = 'currencies';

const store = currenciesModuleFactory.createModuleView(
    STORE_NAME,
    apiService,
    {},
    {
        modules: {
            lookup: currenciesLookup,
        },
    }
);

export default store;
